import { Route, Switch } from "react-router-dom";
import MemberDetail from "../Members/MemberDetail";
import RegistrationsOverview from "./RegistrationsOverview";

export default function MembersController() : JSX.Element {
    return  <Switch>
                <Route path="/apacis/registrations" component={RegistrationsOverview} exact />
                <Route path="/apacis/registrations/view/:uid"><MemberDetail page="registrations" /></Route>
            </Switch>
}